import gql from "graphql-tag";

export const EDIT_TICKET = gql`
mutation update_event_paid_ticket_details_by_pk($id: uuid!, $data: event_paid_ticket_details_set_input) {
    update_event_paid_ticket_details_by_pk(pk_columns: {id: $id}, _set: $data) {
      id
    }
  }
`